import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const AccountRolesModelSchema = z
  .object({
    id: z.string(),
    account_id: z.string().nullish(),
    account_role_choice_id: z.string().nullish()
  })
  .strict()

export const AccountRolesModelFields = makeFieldKeys(AccountRolesModelSchema)

export type AccountRolesModel = z.infer<typeof AccountRolesModelSchema>

function validateAccountRolesModel(data: unknown): AccountRolesModel {
  try {
    return validateWithZodSchema(AccountRolesModelSchema, data, 'account roles model')
  } catch (error) {
    throw new Error(`Account roles model validation failed: ${error}`)
  }
}
